
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Beleg from '@/types/Beleg';
    import {CompareFunction, DataTableHeaders} from '@/types';
    import Impfstelle from '@/types/Impfstelle';
    import moment from 'moment';
    import api from '@/services/Api';
    import {AxiosResponse} from 'axios';
    import Belegposition from '@/types/Belegposition';
    import {ListItems, VDatePickerInput} from '@/types/Components';
    import {Tarifart} from '@/types/Tarifart';
    import {confirmSwal} from '@/helper/swals';
    import {SweetAlertResult} from 'sweetalert2';
    import DatePickerInput from '@/components/DatePickerInput.vue';

    @Component({
        components: {
            DatePickerInput,
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('globals', ['sortDate']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('kassafuehrung', ['offeneZahlscheinBelege', 'loaders', 'dialogs', 'beleg']),
        },
        methods: {
            ...mapActions('kassafuehrung', ['loadOffeneZahlscheinBelege']),
            ...mapActions('patient', ['updateZahlungscheinBeleg']),
            ...mapMutations('kassafuehrung', ['setDialogZahlungseingang', 'setBeleg']),

        },
    })
    export default class RechnungseingangDialog extends Vue {
        @Prop() visible!: boolean;

        public sortDate!: CompareFunction<Beleg>;
        public loadOffeneZahlscheinBelege!: () => void;
        public setBeleg!: (payload: { beleg: Beleg, load: boolean }) => void;
        public setDialogZahlungseingang!: (payload: { zahlungseingang?: boolean}) => void;
        public updateZahlungscheinBeleg!: (beleg: Beleg) => Promise<boolean>;
        public offeneZahlscheinBelege!: Beleg[];
        public impfstelleDetail!: Impfstelle;
        public impfstelle_id!: number;
        public beleg: any;
        public belegpositionen: Belegposition[] = [];

        public $refs!: {
            zahlungseingan: VDatePickerInput;
        };

        public get headers(): DataTableHeaders<Belegposition> {
            return [
                { value: 'anzahl', text: 'Anzahl', width: 150 },
                { value: 'impfstoff_bezeichnung', text: 'Bezeichnung'},
                //{ value: 'tarifart', text: ''},
                { value: 'verkaufspreis_brutto', text: 'Einzelpreis [€]'},
                { value: 'verkaufspreis', text: 'Betrag [€]'},
            ];
        }

        protected belegeSum = (sum: number, beleg: Beleg): number => {
            return sum += (!beleg.isStorniert ? beleg.gesamtbetrag ?? 0 : 0);
        };

        public summe(belege: Beleg[]): number {
            return belege.reduce(this.belegeSum, 0);
        }

        public onClickZahlung(beleg: Beleg) {
            //confirmSwal('Sind Sie sicher?', 'Ist die Rechnung ' + beleg.jahr + ' | ' + beleg.belegnr + ' bezahlt?', 'Ja', 'Abbrechen')
            // .then(({ isConfirmed }: SweetAlertResult) => {
            //if (isConfirmed) {
            //beleg.zahlungseingang = moment().format('YYYY-MM-DD HH:mm:ss');
            this.updateZahlungscheinBeleg(beleg).then(() => {
                this.loadOffeneZahlscheinBelege();
                this.$emit('close');
            });
            // }
            // });
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.belegpositionen = [];
                api.post('ivs/rechnung/getbelegpositionen', { beleg_id: this.beleg.beleg_id})
                    .then((response: AxiosResponse) => {
                        this.belegpositionen = response.data.body;
                    });
                this.watchZahlungseingansdatum();
            }
        }

        /*public readonly tarife: ListItems<Tarifart> = [
            { value: Tarifart.Normal, text: 'Normaltarif' },
            { value: Tarifart.Individuell, text: 'Individualtarif' },
            { value: Tarifart.KeineVerrechnung, text: 'keine Verrechnung' },
            { value: Tarifart.Spaeter, text: 'später verrechnen' },
            { value: Tarifart.Rabatt5, text: '5% Rabatt' },
            { value: Tarifart.Rabatt10, text: '10% Rabatt' },
            { value: Tarifart.Rabatt15, text: '15% Rabatt' },
            { value: Tarifart.Rabatt20, text: '20% Rabatt' },
            { value: Tarifart.Rabatt30, text: '30% Rabatt' },
        ]*/

        @Watch('beleg.zahlungseingang')
        public watchZahlungseingansdatum() {
            if (!this.beleg.zahlungseingang) {
                this.beleg.zahlungseingang = moment(new Date(), true).format('YYYY-MM-DD');
            }
        }
    }
